// Vuex object/icon store module

import icons from '@/assets/icons.js'

export default {
  namespaced : true,
  state      : { icons: icons },
  getters    : {
    icons       : state => state.icons,
    getIconById : state => iconId => state.icons.find(icon => icon.id === iconId)
  }
}



// WEBPACK FOOTER //
// ./src/components/object/store/icon.js